import { Component, OnInit, NgZone, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { IDetect } from 'ngx-barcodeput';
import { LocalSystemService } from '../local-system.service';

@Component({
  selector: 'app-edit-warranty',
  templateUrl: './edit-warranty.component.html',
  styleUrls: ['./edit-warranty.component.scss']
})
export class EditWarrantyComponent implements OnInit {
  availableBrands:any = [];

  warranty_id:any;

  editWarranty:any = { 
    warranty_id:"",
    client_name:"",
    client_email:"",
    client_address:"",
    brand:"1", 
    date_purchase:new Date(), 
    date_installation:new Date(),
    technician:"",
    service_name:"",
    service_address:"",
    tender_dimitrovgrad:0
  };
  timeoutSerialInternal:any;
  timeoutSerialExternal:any
  timeoutClientName:any;
  timeoutSerialInner:any;
  selectingInner:any = false;
  selectingExternal:any = false;
  selectingClient:any = false;

  items:any = [];
  example:any = { selected:false, brand_example:"", model_internal_example:"", model_external_example:"" };

  innerSerialSearches:any = [];
  externalSerialSearches:any = [];
  clientsSearches:any = [];

  purchase_date_picker:any = false;  
  current_purchase_date:any;
  current_purchase_month_dates:any = [];
  installation_date_picker:any = false;
  current_installation_date:any;
  current_installation_month_dates:any = [];

  serialInternalSuggestions:any = [];
  serialExternalSuggestions:any = [];

  selectingTown:any = false;

  tab:any = "general";
  towns:any = [{"name":"гр.Айтос","region":"Бургас","population":22500},{"name":"гр.Аксаково","region":"Варна","population":8206},{"name":"гр.Алфатар","region":"Силистра","population":1608},{"name":"гр.Антоново","region":"Търговище","population":1437},{"name":"гр.Априлци","region":"Ловеч","population":2867},{"name":"гр.Ардино","region":"Кърджали","population":3973},{"name":"гр.Асеновград","region":"Пловдив","population":52896},{"name":"гр.Ахелой","region":"Бургас","population":2109},{"name":"гр.Ахтопол","region":"Бургас","population":1436},{"name":"гр.Балчик","region":"Добрич","population":12726},{"name":"гр.Банкя","region":"София град","population":11662},{"name":"гр.Банско","region":"Благоевград","population":8170},{"name":"гр.Баня","region":"Пловдив","population":3329},{"name":"гр.Батак","region":"Пазарджик","population":3266},{"name":"гр.Батановци","region":"Перник","population":2230},{"name":"гр.Белене","region":"Плевен","population":8318},{"name":"гр.Белица","region":"Благоевград","population":3184},{"name":"гр.Белово","region":"Пазарджик","population":3876},{"name":"гр.Белоградчик","region":"Видин","population":5452},{"name":"гр.Белослав","region":"Варна","population":8129},{"name":"гр.Берковица","region":"Монтана","population":13708},{"name":"гр.Благоевград","region":"Благоевград","population":75397},{"name":"гр.Бобов дол","region":"Кюстендил","population":6040},{"name":"гр.Бобошево","region":"Кюстендил","population":1330},{"name":"гр.Божурище","region":"Софийска","population":5420},{"name":"гр.Бойчиновци","region":"Монтана","population":1487},{"name":"гр.Болярово","region":"Ямбол","population":1245},{"name":"гр.Борово","region":"Русе","population":2252},{"name":"гр.Ботевград","region":"Софийска","population":21407},{"name":"гр.Брацигово","region":"Пазарджик","population":4262},{"name":"гр.Брегово","region":"Видин","population":2572},{"name":"гр.Брезник","region":"Перник","population":4092},{"name":"гр.Брезово","region":"Пловдив","population":1894},{"name":"гр.Брусарци","region":"Монтана","population":1188},{"name":"гр.Бургас","region":"Бургас","population":206722},{"name":"гр.Бухово","region":"София град","population":2913},{"name":"гр.Българово","region":"Бургас","population":2001},{"name":"гр.Бяла","region":"Варна","population":2263},{"name":"гр.Бяла","region":"Русе","population":8921},{"name":"гр.Бяла Слатина","region":"Враца","population":12627},{"name":"гр.Бяла Черква","region":"Велико Търново","population":2606},{"name":"гр.Варна","region":"Варна","population":348136},{"name":"гр.Велики Преслав","region":"Шумен","population":8937},{"name":"гр.Велико Търново","region":"Велико Търново","population":71156},{"name":"гр.Велинград","region":"Пазарджик","population":24800},{"name":"гр.Ветово","region":"Русе","population":4831},{"name":"гр.Ветрен","region":"Пазарджик","population":3152},{"name":"гр.Видин","region":"Видин","population":51699},{"name":"гр.Враца","region":"Враца","population":62000},{"name":"гр.Вълчедръм","region":"Монтана","population":3568},{"name":"гр.Вълчи дол","region":"Варна","population":3425},{"name":"гр.Върбица","region":"Шумен","population":3595},{"name":"гр.Вършец","region":"Монтана","population":6251},{"name":"гр.Габрово","region":"Габрово","population":60364},{"name":"гр.Генерал Тошево","region":"Добрич","population":6963},{"name":"гр.Главиница","region":"Силистра","population":1881},{"name":"гр.Глоджево","region":"Русе","population":3506},{"name":"гр.Годеч","region":"Софийска","population":4332},{"name":"гр.Горна Оряховица","region":"Велико Търново","population":33156},{"name":"гр.Гоце Делчев","region":"Благоевград","population":20358},{"name":"гр.Грамада","region":"Видин","population":1481},{"name":"гр.Гулянци","region":"Плевен","population":3424},{"name":"гр.Гурково","region":"Стара Загора","population":2996},{"name":"гр.Гълъбово","region":"Стара Загора","population":8675},{"name":"гр.Две могили","region":"Русе","population":4252},{"name":"гр.Дебелец","region":"Велико Търново","population":3919},{"name":"гр.Девин","region":"Смолян","population":6587},{"name":"гр.Девня","region":"Варна","population":9259},{"name":"гр.Джебел","region":"Кърджали","population":3200},{"name":"гр.Димитровград","region":"Хасково","population":39934},{"name":"гр.Димово","region":"Видин","population":1193},{"name":"гр.Добринище","region":"Благоевград","population":2668},{"name":"гр.Добрич","region":"Добрич","population":96881},{"name":"гр.Долна баня","region":"Софийска","population":4793},{"name":"гр.Долна Митрополия","region":"Плевен","population":3417},{"name":"гр.Долна Оряховица","region":"Велико Търново","population":2884},{"name":"гр.Долни Дъбник","region":"Плевен","population":4520},{"name":"гр.Долни чифлик","region":"Варна","population":7056},{"name":"гр.Доспат","region":"Смолян","population":2343},{"name":"гр.Драгоман","region":"Софийска","population":3300},{"name":"гр.Дряново","region":"Габрово","population":8028},{"name":"гр.Дулово","region":"Силистра","population":7063},{"name":"гр.Дунавци","region":"Видин","population":2597},{"name":"гр.Дупница","region":"Кюстендил","population":37416},{"name":"гр.Дългопол","region":"Варна","population":4847},{"name":"гр.Елена","region":"Велико Търново","population":5693},{"name":"гр.Елин Пелин","region":"Софийска","population":7278},{"name":"гр.Елхово","region":"Ямбол","population":10492},{"name":"гр.Етрополе","region":"Софийска","population":10951},{"name":"гр.Завет","region":"Разград","population":3250},{"name":"гр.Земен","region":"Перник","population":1749},{"name":"гр.Златарица","region":"Велико Търново","population":2723},{"name":"гр.Златица","region":"Софийска","population":5018},{"name":"гр.Златоград","region":"Смолян","population":7220},{"name":"гр.Ивайловград","region":"Хасково","population":3685},{"name":"гр.Игнатиево","region":"Варна","population":4288},{"name":"гр.Искър","region":"Плевен","population":3462},{"name":"гр.Исперих","region":"Разград","population":9080},{"name":"гр.Ихтиман","region":"Софийска","population":13591},{"name":"гр.Каблешково","region":"Бургас","population":2898},{"name":"гр.Каварна","region":"Добрич","population":11832},{"name":"гр.Казанлък","region":"Стара Загора","population":50850},{"name":"гр.Калофер","region":"Пловдив","population":2921},{"name":"гр.Камено","region":"Бургас","population":5334},{"name":"гр.Каолиново","region":"Шумен","population":1790},{"name":"гр.Карлово","region":"Пловдив","population":24288},{"name":"гр.Карнобат","region":"Бургас","population":18301},{"name":"гр.Каспичан","region":"Шумен","population":3186},{"name":"гр.Кермен","region":"Сливен","population":1738},{"name":"гр.Килифарево","region":"Велико Търново","population":2365},{"name":"гр.Китен","region":"Бургас","population":1131},{"name":"гр.Клисура","region":"Пловдив","population":1093},{"name":"гр.Кнежа","region":"Плевен","population":11060},{"name":"гр.Козлодуй","region":"Враца","population":13677},{"name":"гр.Койнаре","region":"Плевен","population":4541},{"name":"гр.Копривщица","region":"Софийска","population":2348},{"name":"гр.Костандово","region":"Пазарджик","population":4299},{"name":"гр.Костенец","region":"Софийска","population":6633},{"name":"гр.Костинброд","region":"Софийска","population":11849},{"name":"гр.Котел","region":"Сливен","population":5880},{"name":"гр.Кочериново","region":"Кюстендил","population":2288},{"name":"гр.Кресна","region":"Благоевград","population":3656},{"name":"гр.Криводол","region":"Враца","population":3259},{"name":"гр.Кричим","region":"Пловдив","population":8605},{"name":"гр.Крумовград","region":"Кърджали","population":4943},{"name":"гр.Крън","region":"Стара Загора","population":3382},{"name":"гр.Кубрат","region":"Разград","population":7750},{"name":"гр.Куклен","region":"Пловдив","population":5999},{"name":"гр.Кула","region":"Видин","population":3222},{"name":"гр.Кърджали","region":"Кърджали","population":49326},{"name":"гр.Кюстендил","region":"Кюстендил","population":48135},{"name":"гр.Левски","region":"Плевен","population":10922},{"name":"гр.Летница","region":"Ловеч","population":3483},{"name":"гр.Ловеч","region":"Ловеч","population":37568},{"name":"гр.Лозница","region":"Разград","population":2297},{"name":"гр.Лом","region":"Монтана","population":24522},{"name":"гр.Луковит","region":"Ловеч","population":9583},{"name":"гр.Лъки","region":"Пловдив","population":2402},{"name":"гр.Любимец","region":"Хасково","population":7681},{"name":"гр.Лясковец","region":"Велико Търново","population":8629},{"name":"гр.Мадан","region":"Смолян","population":6578},{"name":"гр.Маджарово","region":"Хасково","population":724},{"name":"гр.Малко Търново","region":"Бургас","population":2397},{"name":"гр.Мартен","region":"Русе","population":3704},{"name":"гр.Мездра","region":"Враца","population":10927},{"name":"гр.Мелник","region":"Благоевград","population":334},{"name":"гр.Меричлери","region":"Хасково","population":1812},{"name":"гр.Мизия","region":"Враца","population":3282},{"name":"гр.Момин проход","region":"Софийска","population":1611},{"name":"гр.Момчилград","region":"Кърджали","population":8317},{"name":"гр.Монтана","region":"Монтана","population":45191},{"name":"гр.Мъглиж","region":"Стара Загора","population":3479},{"name":"гр.Неделино","region":"Смолян","population":4273},{"name":"гр.Несебър","region":"Бургас","population":13710},{"name":"гр.Николаево","region":"Стара Загора","population":3147},{"name":"гр.Никопол","region":"Плевен","population":3907},{"name":"гр.Нова Загора","region":"Сливен","population":24074},{"name":"гр.Нови Искър","region":"София град","population":14005},{"name":"гр.Нови пазар","region":"Шумен","population":13652},{"name":"гр.Обзор","region":"Бургас","population":2480},{"name":"гр.Омуртаг","region":"Търговище","population":9195},{"name":"гр.Опака","region":"Търговище","population":2776},{"name":"гр.Оряхово","region":"Враца","population":5562},{"name":"гр.Павел баня","region":"Стара Загора","population":2843},{"name":"гр.Павликени","region":"Велико Търново","population":10952},{"name":"гр.Пазарджик","region":"Пазарджик","population":77103},{"name":"гр.Панагюрище","region":"Пазарджик","population":17929},{"name":"гр.Перник","region":"Перник","population":79044},{"name":"гр.Перущица","region":"Пловдив","population":5139},{"name":"гр.Петрич","region":"Благоевград","population":31141},{"name":"гр.Пещера","region":"Пазарджик","population":20467},{"name":"гр.Пирдоп","region":"Софийска","population":7536},{"name":"гр.Плачковци","region":"Габрово","population":1811},{"name":"гр.Плевен","region":"Плевен","population":112840},{"name":"гр.Плиска","region":"Шумен","population":1014},{"name":"гр.Пловдив","region":"Пловдив","population":368853},{"name":"гр.Полски Тръмбеш","region":"Велико Търново","population":4586},{"name":"гр.Поморие","region":"Бургас","population":14003},{"name":"гр.Попово","region":"Търговище","population":16047},{"name":"гр.Пордим","region":"Плевен","population":2111},{"name":"гр.Правец","region":"Софийска","population":4321},{"name":"гр.Приморско","region":"Бургас","population":3546},{"name":"гр.Провадия","region":"Варна","population":13145},{"name":"гр.Първомай","region":"Пловдив","population":14091},{"name":"гр.Раднево","region":"Стара Загора","population":13329},{"name":"гр.Радомир","region":"Перник","population":14342},{"name":"гр.Разград","region":"Разград","population":35177},{"name":"гр.Разлог","region":"Благоевград","population":12820},{"name":"гр.Ракитово","region":"Пазарджик","population":8648},{"name":"гр.Раковски","region":"Пловдив","population":15586},{"name":"гр.Рила","region":"Кюстендил","population":2783},{"name":"гр.Роман","region":"Враца","population":3013},{"name":"гр.Рудозем","region":"Смолян","population":3625},{"name":"гр.Русе","region":"Русе","population":160511},{"name":"гр.Садово","region":"Пловдив","population":2407},{"name":"гр.Самоков","region":"Софийска","population":27348},{"name":"гр.Сандански","region":"Благоевград","population":28342},{"name":"гр.Сапарева баня","region":"Кюстендил","population":4128},{"name":"гр.Свети Влас","region":"Бургас","population":4092},{"name":"гр.Свиленград","region":"Хасково","population":18802},{"name":"гр.Свищов","region":"Велико Търново","population":32132},{"name":"гр.Своге","region":"Софийска","population":8084},{"name":"гр.Севлиево","region":"Габрово","population":24558},{"name":"гр.Сеново","region":"Русе","population":1449},{"name":"гр.Септември","region":"Пазарджик","population":8504},{"name":"гр.Силистра","region":"Силистра","population":38364},{"name":"гр.Симеоновград","region":"Хасково","population":6988},{"name":"гр.Симитли","region":"Благоевград","population":7199},{"name":"гр.Славяново","region":"Плевен","population":4351},{"name":"гр.Сливен","region":"Сливен","population":96598},{"name":"гр.Сливница","region":"Софийска","population":7268},{"name":"гр.Сливо поле","region":"Русе","population":3322},{"name":"гр.Смолян","region":"Смолян","population":30785},{"name":"гр.Смядово","region":"Шумен","population":4049},{"name":"гр.Созопол","region":"Бургас","population":5236},{"name":"гр.Сопот","region":"Пловдив","population":9125},{"name":"гр.София","region":"София град","population":1281148},{"name":"гр.Средец","region":"Бургас","population":9161},{"name":"гр.Стамболийски","region":"Пловдив","population":11662},{"name":"гр.Стара Загора","region":"Стара Загора","population":149439},{"name":"гр.Стражица","region":"Велико Търново","population":5323},{"name":"гр.Стралджа","region":"Ямбол","population":6349},{"name":"гр.Стрелча","region":"Пазарджик","population":4226},{"name":"гр.Суворово","region":"Варна","population":5054},{"name":"гр.Сунгурларе","region":"Бургас","population":3292},{"name":"гр.Сухиндол","region":"Велико Търново","population":1996},{"name":"гр.Съединение","region":"Пловдив","population":5788},{"name":"гр.Сърница","region":"Пазарджик","population":3590},{"name":"гр.Твърдица","region":"Сливен","population":6082},{"name":"гр.Тервел","region":"Добрич","population":6764},{"name":"гр.Тетевен","region":"Ловеч","population":10185},{"name":"гр.Тополовград","region":"Хасково","population":5474},{"name":"гр.Троян","region":"Ловеч","population":22179},{"name":"гр.Трън","region":"Перник","population":2552},{"name":"гр.Тръстеник","region":"Плевен","population":4536},{"name":"гр.Трявна","region":"Габрово","population":9621},{"name":"гр.Тутракан","region":"Силистра","population":9567},{"name":"гр.Търговище","region":"Търговище","population":39836},{"name":"гр.Угърчин","region":"Ловеч","population":2731},{"name":"гр.Хаджидимово","region":"Благоевград","population":2702},{"name":"гр.Харманли","region":"Хасково","population":19617},{"name":"гр.Хасково","region":"Хасково","population":77365},{"name":"гр.Хисаря","region":"Пловдив","population":7264},{"name":"гр.Цар Калоян","region":"Разград","population":3742},{"name":"гр.Царево","region":"Бургас","population":6268},{"name":"гр.Чепеларе","region":"Смолян","population":5332},{"name":"гр.Червен бряг","region":"Плевен","population":13958},{"name":"гр.Черноморец","region":"Бургас","population":2186},{"name":"гр.Чипровци","region":"Монтана","population":1835},{"name":"гр.Чирпан","region":"Стара Загора","population":16517},{"name":"гр.Шабла","region":"Добрич","population":3488},{"name":"гр.Шивачево","region":"Сливен","population":3833},{"name":"гр.Шипка","region":"Стара Загора","population":1355},{"name":"гр.Шумен","region":"Шумен","population":89365},{"name":"гр.Ябланица","region":"Ловеч","population":2799},{"name":"гр.Якоруда","region":"Благоевград","population":5512},{"name":"гр.Ямбол","region":"Ямбол","population":77150}]

  modal:any = { open:false, cntx:'', obj:'' }

  warranty_text:any = [];
  currentWarrantyText:any = { uid:'-1' };

  @HostListener('window:beforeunload')
  onBeforeUnload() {
      return confirm("Сигурни ли сте, че искате да излезете в процес на добавяне ?");
  }

  constructor(private http:HttpClient, private router:Router, private activatedRoute:ActivatedRoute, private ngZone:NgZone, public system:LocalSystemService) { 
    this.current_purchase_date = this.editWarranty.date_purchase;
    this.current_installation_date = this.editWarranty.date_installation;
    this.warranty_id = this.activatedRoute.snapshot.params.uid;
    this.getWarranty();
    this.getBrands();
  }

  ngOnInit(): void {
  }

  switchTab(tab) { this.tab = tab; }

  getWarranty() {
    this.openModal('loading', {});
    this.http.get("api/service.php?action=get_warranties&uid=" + this.warranty_id).subscribe((data) => {
      this.editWarranty.warranty_id = data['warranties'][0]['warranty_id'];
      this.editWarranty.client_name = data['warranties'][0]['client_name'];
      this.editWarranty.client_address = data['warranties'][0]['client_address']
      this.editWarranty.client_email = data['warranties'][0]['client_email']
      this.editWarranty.client_phone = data['warranties'][0]['client_phone']
      this.editWarranty.technician = data['warranties'][0]['technician'];
      this.editWarranty.service_name = data['warranties'][0]['service_name'];
      this.editWarranty.service_address = data['warranties'][0]['service_address'];
      this.editWarranty.service_phone = data['warranties'][0]['service_phone'];
      this.editWarranty.town = data['warranties'][0]['town'];
      this.editWarranty.warranty_periods = data['warranties'][0]['warranty_times'];
      if(data['warranties'][0]['tender_dimitrovgrad'] == 1) { this.editWarranty.tender_dimitrovgrad = true; }
      else { this.editWarranty.tender_dimitrovgrad = false; }
      let brand_split = data['warranties'][0]['brand'].split(";");
      let model_indoor_split = data['warranties'][0]['model_indoor'].split(";");
      let model_outdoor_split = data['warranties'][0]['model_outdoor'].split(";");
      let serial_indoor_split = data['warranties'][0]['serial_number_indoor'].split(";");
      let serial_outdoor_split = data['warranties'][0]['serial_number_outdoor'].split(";");
      for(let i = 0; i < brand_split.length; i++){
        this.items.push({ selected:false, brand:brand_split[i], model_internal:model_indoor_split[i], model_external:model_outdoor_split[i], serial_internal:serial_indoor_split[i], serial_external:serial_outdoor_split[i] });
      }
      this.items.push({ selected:false, brand:"", model_internal:"", model_external:"", serial_internal:"", serial_external:"" });

      this.editWarranty.date_purchase = new Date(data['warranties'][0]['purchase_date']);
      this.editWarranty.date_installation = new Date(data['warranties'][0]['installation_date']);
      this.current_purchase_date = this.editWarranty.date_purchase;
      this.current_installation_date = this.editWarranty.date_installation;

      this.currentWarrantyText = { uid:data['warranties'][0]['warranty_text'] }
      if(this.system.returnIsAdmin() || this.system.returnRole() == 3) {
        this.getWarrantyText();
      }
      this.ngZone.run(()=>{});
      setTimeout(()=>{                           //<<<---using ()=> syntax
        this.closeModal();
      }, 500);

      setTimeout(()=>{                           //<<<---using ()=> syntax
        let warranty_periods = this.editWarranty.warranty_periods.split(";");
        for(var x = 0; x < warranty_periods.length; x++) {
          let split_warranty = warranty_periods[x].split(":");
          if(this.availableBrands.filter(brand => brand.name == split_warranty[0]).length > 0) {
            this.availableBrands.filter(brand => brand.name == split_warranty[0])[0].warranty_period = parseInt(split_warranty[1]);
          }
        }
      }, 1000);
    });
  }

  getWarrantyText() {
    this.http.get("api/service.php?action=get_warranty_text").subscribe((data) => {
      this.warranty_text = data['warranty_text'];
      let found = false;
      for(let i = 0; i < this.warranty_text.length; i++) {
        this.warranty_text[i].layout = this.decodeHTMLEntities(this.warranty_text[i].layout);
        if(this.currentWarrantyText.uid == "-1") {
          if(this.warranty_text[i].default_warranty == "1") {
            this.currentWarrantyText = this.warranty_text[i];
            found = true;
          }
        } else if(this.currentWarrantyText.uid == this.warranty_text[i].uid) {
          this.currentWarrantyText = this.warranty_text[i];
          found = true;
        }
      }

      if(!found) {
        for(let i = 0; i < this.warranty_text.length; i++) {
          if(this.warranty_text[i].default_warranty == "1") {
            this.currentWarrantyText = this.warranty_text[i];
            found = true;
          }
        }
      }
      this.closeModal();
      this.ngZone.run(()=>{});
    });
  }


  getBrands() {
    this.http.get("api/service.php?action=get_brands").subscribe((data) => {
      this.availableBrands = data['brands'];
    });
  }

  searchInner(){
    if(this.editWarranty.serial_internal.length > 3) {
      clearTimeout(this.timeoutSerialInner);
      this.timeoutSerialInner = setTimeout(()=>{                           //<<<---using ()=> syntax
        this.http.get("api/service.php?action=search_product_internal&serial=" + this.editWarranty.serial_internal).subscribe((data) => {
          if(data['products'].length == 1) {
            // this.editWarranty.serial_internal = data['products'][0].serial_number;
            this.editWarranty.model_internal = data['products'][0].model;
            this.editWarranty.brand = data['products'][0].brand;
          } else {
            this.innerSerialSearches = data['products'];
          }
        });
      }, 300);
    }
  }

  searchExternal(){
    if(this.editWarranty.serial_external.length > 3) {
      clearTimeout(this.timeoutSerialExternal);
      this.timeoutSerialInner = setTimeout(()=>{                           //<<<---using ()=> syntax
        this.http.get("api/service.php?action=search_product_external&serial=" + this.editWarranty.serial_external).subscribe((data) => {
          if(data['products'].length == 1) {
            // this.editWarranty.serial_external = data['products'][0].serial_number;
            this.editWarranty.model_external = data['products'][0].model;
            this.editWarranty.brand = data['products'][0].brand;
          } else {
            this.externalSerialSearches = data['products'];
          }
        });
      }, 300);
    }
  }

  searchClient() {
    if(this.editWarranty.client_name.length > 3) {
      clearTimeout(this.timeoutClientName);
      this.timeoutClientName = setTimeout(()=>{                           //<<<---using ()=> syntax
        this.http.get("api/service.php?action=search_for_client&name=" + this.editWarranty.client_name).subscribe((data) => {
          this.clientsSearches = data['clients'];
        });
      }, 300);
    }
  }

  EditWarranty() {
    this.openModal('editting-warranty', {});
    let warranty_periods = "";
    let first_added = false;
    let tender_dimitrovgrad = 0;
    for(var ai = 0; ai < this.availableBrands.length; ai++) {
      if(this.returnIsBrandAdded(this.availableBrands[ai])) {
        if(first_added) { warranty_periods += ";"; }
        warranty_periods += this.availableBrands[ai].name + ":" + this.availableBrands[ai].warranty_period;
        first_added = true;
      }
    }
    if(this.editWarranty.tender_dimitrovgrad) { tender_dimitrovgrad = 1; }
    let postObject = { 'items':[], 'uid':this.warranty_id, 'client_name':this.editWarranty.client_name, 'client_address':this.editWarranty.client_address, 
    'town':this.editWarranty.town,
    'client_email':this.editWarranty.client_email, 'client_phone':this.editWarranty.client_phone, 'brand':this.editWarranty.brand, 
    'date_purchase':this.returnDateFormatedForStorage(this.editWarranty.date_purchase), 'date_installation':this.returnDateFormatedForStorage(this.editWarranty.date_installation),
    'service_name':this.editWarranty.service_name, 'technician':this.editWarranty.technician, 'service_address':this.editWarranty.service_address, 'service_phone':this.editWarranty.service_phone, 'warranty_text':this.currentWarrantyText.uid,
    'warranty_period':warranty_periods, 'tender_dimitrovgrad':tender_dimitrovgrad
  };
    for(let i = 0; i < this.items.length; i++) {
      postObject.items.push(this.items[i]);
    }
    this.http.post("api/service.php?action=edit_warranty", postObject).subscribe((data) => {
      this.router.navigate(['warranties']);
    });
  }

  checkForNewRow(idx:number, type:String){
    if(idx == this.items.length - 1) {
      if(this.items[idx].brand != "" || this.items[idx].model_internal != "" || this.items[idx].model_external != "" || this.items[idx].serial_internal != "" || this.items[idx].serial_external != ""){
        this.items.push({ selected:false, brand:this.example.brand_example, model_internal:this.example.model_internal_example, model_external:this.example.model_external_example, serial_internal:"", serial_external:"" });
      }
    }

    this.items[idx].model_internal = this.items[idx].model_internal.toUpperCase();
    this.items[idx].model_external = this.items[idx].model_external.toUpperCase();

    this.items[idx].serial_internal = this.items[idx].serial_internal.toUpperCase();
    this.items[idx].serial_external = this.items[idx].serial_external.toUpperCase();
    this.items[idx].serial_internal = this.returnTranslate(this.items[idx].serial_internal);
    this.items[idx].serial_external = this.returnTranslate(this.items[idx].serial_external);

    if(type == 'serial_internal') { this.searchSerialInternal(idx) }
    else if(type == 'serial_external') { this.searchSerialExternal(idx); }
    // if(type == 'model_internal') { this.searchModelInternal(idx) }
    // else if(type == 'model_external') { this.searchModelExternal(idx); }
  }

  selectInner(product){
    this.editWarranty.serial_internal = product.serial_number;
    this.editWarranty.model_internal = product.model;
    if(product.brand != '') { this.editWarranty.brand = product.brand; }
    this.selectingInner = false;
  }

  selectExternal(product) {
    this.editWarranty.serial_external = product.serial_number;
    this.editWarranty.model_external = product.model;
    if(product.brand != '') { this.editWarranty.brand = product.brand; }
    this.selectingExternal = false;
  }

  selectClient(client) {
    this.editWarranty.client_name = client.name;
    this.editWarranty.client_address = client.address;
    this.editWarranty.client_email = client.email;
    this.selectingClient = false;
    // this.editWarranty.serial_external = product.serial_number;
    // this.editWarranty.model_external = product.model;
    // this.editWarranty.brand = product.brand;
  }

  openPurchasePicker() {
    this.timeoutSerialInner = setTimeout(()=>{      
      this.purchase_date_picker = true; 
      this.current_purchase_date = new Date(this.editWarranty.date_purchase);
      this.Formulate(this.current_purchase_date);
    }, 50);
  }

  selectPurchaseDate(dt){
    this.editWarranty.date_purchase.setYear(this.current_purchase_date.getFullYear());
    this.editWarranty.date_purchase.setDate(dt.date);
    this.editWarranty.date_purchase.setMonth(dt.month);
    this.purchase_date_picker = false;
  }

  nextPurchaseMonth() { this.current_purchase_date.setMonth(this.current_purchase_date.getMonth() + 1); this.Formulate(this.current_purchase_date); }
  prevPurchaseMonth() { this.current_purchase_date.setMonth(this.current_purchase_date.getMonth() - 1); this.Formulate(this.current_purchase_date); }

  openInstallationPicker() {
    this.timeoutSerialInner = setTimeout(()=>{      
      this.installation_date_picker = true; 
      this.current_installation_date = new Date(this.editWarranty.date_installation);
      this.Formulate(this.current_installation_date);
    }, 50);
  }

  selectInstallationDate(dt){
    this.editWarranty.date_installation.setYear(this.current_installation_date.getFullYear());
    this.editWarranty.date_installation.setDate(dt.date);
    this.editWarranty.date_installation.setMonth(dt.month);
    this.installation_date_picker = false;
  }

  nextInstallationMonth() { this.current_installation_date.setMonth(this.current_installation_date.getMonth() + 1); this.Formulate(this.current_installation_date); }
  prevInstallationMonth() { this.current_installation_date.setMonth(this.current_installation_date.getMonth() - 1); this.Formulate(this.current_installation_date); }


  deselectInner() {
    setTimeout(()=>{
      this.selectingInner = false
    }, 500);
  }

  deselectExternal() {
    setTimeout(()=>{
      this.selectingExternal = false
    }, 500);
  }

  deselectClient() {
    setTimeout(()=>{
      this.selectingClient = false
    }, 500);
  }

  deselectItemInternal(idx) {
    setTimeout(()=>{
      this.items[idx].selectingInternal = false
    }, 300);
  }

  deselectItemExternal(idx) {
    setTimeout(()=>{
      this.items[idx].selectingExternal = false
    }, 300);
  }


  Formulate(dt) {
    this.current_purchase_month_dates = [];

    var firstDay = new Date(dt.getFullYear(), dt.getMonth(), 1);
    var lastDay = new Date(dt.getFullYear(), dt.getMonth() + 1, 0);
    let predate_num = 0;
    // GENERATE PREDATE

    for(let i = 0; i < 42 - lastDay.getDate(); i++) {
        let day_idx = i;
        let first_day = firstDay.getDay();
        if(first_day == 0) { first_day = 7; }
        if(day_idx < first_day - 1) {
            let negative_day = day_idx * -1;
            let date_reformed = new Date(dt.getFullYear(), dt.getMonth(), negative_day);
            this.current_purchase_month_dates.unshift({ "date": date_reformed.getDate(), "month":date_reformed.getMonth(), "active":false})
            predate_num += 1;
        }
    }
    for(let i = 0; i < lastDay.getDate(); i++) {
        let day_id = i + 1;
        this.current_purchase_month_dates.push({ "date":day_id, "month":dt.getMonth(), "active":true });
    }
    for(let i = 0; i < 42 - lastDay.getDate() - predate_num; i++) {
        let date_reformed = new Date(dt.getFullYear(), dt.getMonth() + 2, i + 1);
        this.current_purchase_month_dates.push({ "date":date_reformed.getDate(), "month":date_reformed.getMonth(), "active":false });
    }
  }

  public onDetected(event: IDetect, field:String, idx:number) {
    if(field == 'serial_internal') {
      if(idx < this.items.length - 1) {
        document.getElementById('serial_internal' + [idx + 1])?.focus();
      }
    } else if(field == 'serial_external') {
      if(idx < this.items.length - 1) {
        document.getElementById('serial_external' + [idx + 1])?.focus();
      }
    }
    /* {event: KeyboardEvent, value: "sezmars", time: 0.07083499999716878, type: "scanner"} */
    /* {event: KeyboardEvent, value: "3333333", time: 0.17083499999716878, type: "keyboard"} */
  }

  searchSerialInternal(idx) {
    if(this.items[idx].serial_internal.length > 3) {
      clearTimeout(this.timeoutSerialInternal);
      this.timeoutSerialInternal = setTimeout(()=>{                           //<<<---using ()=> syntax
        this.http.get("api/service.php?action=search_product_internal&serial=" + this.items[idx].serial_internal).subscribe((data) => {
          if(data['products'].length == 1) {
            // this.items[idx].serial_internal = data['products'][0].serial_number;
            this.items[idx].model_internal = data['products'][0].model;
            this.applyItemBrand(idx, data['products'][0].brand);
          } else {
            this.serialInternalSuggestions = data['products'];
          }
        });
      }, 300);
    }
  }

  searchSerialExternal(idx) {
    if(this.items[idx].serial_external.length > 3) {
      clearTimeout(this.timeoutSerialExternal);
      this.timeoutSerialExternal = setTimeout(()=>{                           //<<<---using ()=> syntax
        this.http.get("api/service.php?action=search_product_external&serial=" + this.items[idx].serial_external).subscribe((data) => {
          if(data['products'].length == 1) {
            // this.items[idx].serial_external = data['products'][0].serial_number;
            this.items[idx].model_external = data['products'][0].model;
          } else {
            this.serialExternalSuggestions = data['products'];
          }
        });
      }, 300);
    }
  }

  selectInternalProduct(idx, product) {
    this.items[idx].serial_internal = product.serial_number;
    this.items[idx].model_internal = product.model;
    this.applyItemBrand(idx, product.brand);
  }

  returnLockedBrand(excludeIndex?: number) {
    for(let i = 0; i < this.items.length; i++) {
      if(excludeIndex !== undefined && i === excludeIndex) { continue; }
      if(this.items[i].brand) { return this.items[i].brand; }
    }
    return '';
  }

  returnBrandDisabled(brandName: string, index: number) {
    const locked = this.returnLockedBrand(index);
    return locked !== '' && brandName !== locked;
  }

  returnSingleBrand() {
    const brands = [];
    for(let i = 0; i < this.items.length; i++) {
      if(this.items[i].brand && brands.indexOf(this.items[i].brand) === -1) { brands.push(this.items[i].brand); }
    }
    return brands.length <= 1;
  }

  onBrandChange(idx: number) {
    const locked = this.returnLockedBrand(idx);
    if(locked && this.items[idx].brand && this.items[idx].brand !== locked) {
      this.items[idx].brand = locked;
      return;
    }
    this.checkForNewRow(idx, '');
  }

  applyItemBrand(idx: number, brand: string) {
    if(!brand) { return; }
    const locked = this.returnLockedBrand(idx);
    this.items[idx].brand = locked && brand !== locked ? locked : brand;
  }

  selectExternalProduct(idx, product) {
    this.items[idx].serial_external = product.serial_number;
    this.items[idx].model_external = product.model;
  }


  selectTown(town) {
    this.editWarranty.town = town.name;
    this.selectingTown = false;
  }


  deselectTown() {
    setTimeout(()=>{
      this.selectingTown = false
    }, 500);
  }


  returnDateFormatedForStorage(dt) {
    return dt.getFullYear() + "-" + this.returnPadZero(dt.getMonth()+ 1, 2) + "-" + this.returnPadZero(dt.getDate(), 2) +  " " +  this.returnPadZero(dt.getHours(), 2) + ":" + this.returnPadZero(dt.getMinutes(), 2) + ":" + this.returnPadZero(dt.getSeconds(), 2);
  }


  removeItem(idx:number) { this.items.splice(idx, 1); }

  openModal(cntx, obj){ this.modal = { open:true, 'cntx':cntx, 'obj':obj }; }
  closeModal() { this.modal.open = false; }



  returnDateFormated(dt){
    return this.returnPadZero(dt.getDate(), 2) + "-" + this.returnPadZero(dt.getMonth()+ 1, 2) + "-" + dt.getFullYear();
  }

  returnYear(dt) { return dt.getFullYear(); }
  returnMonth(dt) { return dt.getMonth() + 1; }
  returnMonthName(month) {
    if(month == 1) { return "Януари"; }
    else if(month == 2) { return "Февруари"; }
    else if(month == 3) { return "Март"; }
    else if(month == 4) { return "Април"; }
    else if(month == 5) { return "Май"; }
    else if(month == 6) { return "Юни"; }
    else if(month == 7) { return "Юли"; }
    else if(month == 8) { return "Август"; }
    else if(month == 9) { return "Септември"; }
    else if(month == 10) { return "Октомври"; }
    else if(month == 11) { return "Ноември"; }
    else if(month == 12) { return "Декември"; }
    else { return ""; }
  }
  returnDate(dt) { return dt.getDate();  }

  returnPadZero(number, length) {
    var my_string = '' + number;
    while (my_string.length < length) {
        my_string = '0' + my_string;
    }
    return my_string;
  }

  returnMonthDates() {

  }

  returnIsValid() {
    let validated = false;
    if(this.editWarranty.client_name.length > 0 && this.editWarranty.client_address.length > 0) {
      if(this.editWarranty.client_email.length == 0 || this.returnValidateEmail(this.editWarranty.client_email)) {
        validated = true;
      }
    }
    return validated;
  }

  returnMissingFields() {
    const missing = [];
    const email = this.editWarranty.client_email || '';
    if(!this.editWarranty.client_name || this.editWarranty.client_name.length < 1) { missing.push('име на клиент'); }
    if(!this.editWarranty.client_address || this.editWarranty.client_address.length < 1) { missing.push('адрес на монтаж'); }
    if(email.length > 0 && !this.returnValidateEmail(email)) { missing.push('валиден имейл'); }
    return missing;
  }

  returnValidateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  returnTotalProducts() {
    return this.items.filter(item => item.brand != '' || item.model_internal != '' || item.model_external != '' || item.serial_internal != '' || item.serial_external != '').length;
  }

  returnFilteredTown() {
    return this.towns.filter(town => town.name.toLowerCase().indexOf(this.editWarranty.town.toLowerCase()) > -1);
  }

  returnTranslate = function(text) {
    text = text
        .replace(/\u0401/g, '')
        .replace(/\u0419/g, '')
        .replace(/\u0426/g, '')
        .replace(/\u0423/g, '')
        .replace(/\u041A/g, '')
        .replace(/\u0415/g, '')
        .replace(/\u041D/g, '')
        .replace(/\u0413/g, '')
        .replace(/\u0428/g, '')
        .replace(/\u0429/g, '')
        .replace(/\u0417/g, '')
        .replace(/\u0425/g, '')
        .replace(/\u042A/g, '')
        .replace(/\u0451/g, '')
        .replace(/\u0439/g, '')
        .replace(/\u0446/g, '')
        .replace(/\u0443/g, '')
        .replace(/\u043A/g, '')
        .replace(/\u0435/g, '')
        .replace(/\u043D/g, '')
        .replace(/\u0433/g, '')
        .replace(/\u0448/g, '')
        .replace(/\u0449/g, '')
        .replace(/\u0437/g, '')
        .replace(/\u0445/g, '')
        .replace(/\u044A/g, "")
        .replace(/\u0424/g, '')
        .replace(/\u042B/g, '')
        .replace(/\u0412/g, '')
        .replace(/\u0410/g, '')
        .replace(/\u041F/g, '')
        .replace(/\u0420/g, '')
        .replace(/\u041E/g, '')
        .replace(/\u041B/g, '')
        .replace(/\u0414/g, '')
        .replace(/\u0416/g, '')
        .replace(/\u042D/g, '')
        .replace(/\u0444/g, '')
        .replace(/\u044B/g, '')
        .replace(/\u0432/g, '')
        .replace(/\u0430/g, '')
        .replace(/\u043F/g, '')
        .replace(/\u0440/g, '')
        .replace(/\u043E/g, '')
        .replace(/\u043B/g, '')
        .replace(/\u0434/g, '')
        .replace(/\u0436/g, '')
        .replace(/\u044D/g, '')
        .replace(/\u042F/g, '')
        .replace(/\u0427/g, '')
        .replace(/\u0421/g, '')
        .replace(/\u041C/g, '')
        .replace(/\u0418/g, '')
        .replace(/\u0422/g, '')
        .replace(/\u042C/g, "")
        .replace(/\u0411/g, '')
        .replace(/\u042E/g, '')
        .replace(/\u044F/g, '')
        .replace(/\u0447/g, '')
        .replace(/\u0441/g, '')
        .replace(/\u043C/g, '')
        .replace(/\u0438/g, '')
        .replace(/\u0442/g, '')
        .replace(/\u044C/g, "")
        .replace(/\u0431/g, '')
        .replace(/\u044E/g, '');

    return text;
  };

  decodeHTMLEntities(text) {
    var entities = [
        ['amp', '&'],
        ['apos', '\''],
        ['#x27', '\''],
        ['#x2F', '/'],
        ['#39', '\''],
        ['#47', '/'],
        ['lt', '<'],
        ['gt', '>'],
        ['nbsp', ' '],
        ['quot', '"']
    ];

    for (var i = 0, max = entities.length; i < max; ++i) 
        text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);

    return text;
  }

  encodeHTMLEntities(text) {
    var entities = [
        ['&','amp'],
        ['\'','apos'],
        ['\'','#x27'],
        ['/','#x2F'],
        ['\'','#39'],
        ['/','#47'],
        ['<','lt'],
        ['>','gt'],
        [' ','nbsp'],
        ['"','quot']
    ];

    for (var i = 0, max = entities.length; i < max; ++i) 
        text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);

    return text;
  }

  returnIsBrandAdded(brand) {
    if(this.items.filter(item => item.brand == brand.name).length > 0) { return true; } else { return false; }
  }
}
